export function AdvertiseBenefitsGrid({ items, columns = 3 }) {
  const colClass = columns === 4 ? 'md:grid-cols-4' : columns === 2 ? 'md:grid-cols-2' : 'md:grid-cols-3';
  return (
    <div className={`reveal grid grid-cols-1 gap-6 ${colClass}`}>
      {items.map((b) => (
        <div key={b.title} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          <div className="grid h-12 w-12 place-items-center rounded-xl bg-blue-50 text-blue-600"><b.icon size={22} /></div>
          <h3 className="mt-4 text-lg font-semibold text-slate-900">{b.title}</h3>
          <p className="mt-1 text-sm text-slate-600">{b.desc}</p>
        </div>
      ))}
    </div>
  );
}
